export function initFadeUpAnimations() {
    gsap.utils.toArray(".fade-up").forEach((el, index) => {
        gsap.from(el, {
            scrollTrigger: {
            trigger: el,
            start: "top 85%",
            },
            y: 40,
            opacity: 0,
            duration: 0.4,
            ease: "power2.out",
            delay: index * 0   // 0s, 0.15s, 0.30s, 0.45s ...
        });
    });
}